import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

const OrganizationalStructure = () => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:600px)");

  const boxStyle = {
    background: "lightgray",
    minHeight: "85vh",
    padding: isMobile ? "1rem" : "3rem",
    fontFamily: "Arial, sans-serif",
    textAlign: "center",
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    padding: "10px 16px",
    margin: "10px",
    borderRadius: "8px",
    border: "2px solid dodgerblue",
    boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
    display: "inline-block",
    minWidth: "220px",
    maxWidth: "280px",
    fontWeight: 500,
    fontSize: "14px",
  };

  const arrowStyle = {
    width: "2px",
    height: "20px",
    backgroundColor: "#1e3a8a",
    margin: "0 auto",
  };

  const connectorStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: "10px",
  };

  return (
    <Box sx={boxStyle}>
      <Typography variant="h4" sx={{ fontWeight: "bold", color: "dodgerblue", mb: 4 }}>
        {t("orgStructure.title")}
      </Typography>

      <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
        {t("orgStructure.boardOfDirectors")}
      </Typography>

      <Box sx={{ ...cardStyle, margin: "0 auto" }}>
        <Typography sx={{ fontWeight: "bold" }}>{t("orgStructure.chairman.name")}</Typography>
        <Typography variant="body2">{t("orgStructure.chairman.role")}</Typography>
      </Box>

      <Box sx={arrowStyle} />

      <Box sx={{ ...cardStyle, margin: "0 auto" }}>
        <Typography sx={{ fontWeight: "bold" }}>{t("orgStructure.ceo.name")}</Typography>
        <Typography variant="body2">{t("orgStructure.ceo.role")}</Typography>
      </Box>

      <Box sx={arrowStyle} />

      <Box sx={connectorStyle}>
        {["executiveDirector", "nonExecutiveDirector", "independentDirector", "advisoryMember"].map((roleKey, i) => (
          <Box key={i}>
            <Box sx={arrowStyle} />
            <Box sx={cardStyle}>
              <Typography>{t(`orgStructure.roles.${roleKey}`)}</Typography>
            </Box>
          </Box>
        ))}
      </Box>

      <Typography variant="h6" sx={{ fontWeight: "bold", mt: 6, mb: 2 }}>
        {t("orgStructure.executiveManagement")}
      </Typography>

      <Box sx={{ ...cardStyle, margin: "0 auto" }}>
        <Typography sx={{ fontWeight: "bold" }}>{t("orgStructure.ceo.name")}</Typography>
        <Typography variant="body2">{t("orgStructure.ceo.role")}</Typography>
      </Box>

      <Box sx={arrowStyle} />

      <Box sx={connectorStyle}>
        {["gm", "cfo", "coo", "cmo"].map((roleKey, i) => (
          <Box key={i}>
            <Box sx={arrowStyle} />
            <Box sx={cardStyle}>
              <Typography>{t(`orgStructure.roles.${roleKey}`)}</Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default OrganizationalStructure;
